import React from "react";
import { Col, Row } from "react-bootstrap";
import Angular from "../../Assets/TechIcons/Angular.svg";
import C from "../../Assets/TechIcons/C++.svg";
import Javascript from "../../Assets/TechIcons/Javascript.svg";
import Node from "../../Assets/TechIcons/Node.svg";
import ReactIcon from "../../Assets/TechIcons/React.svg";
import Java from "../../Assets/TechIcons/Java.svg";
import Python from "../../Assets/TechIcons/Python.svg";
import Typescript from "../../Assets/TechIcons/Typescript.svg";
import Git from "../../Assets/TechIcons/Git.svg";
import Docker from "../../Assets/TechIcons/Docker.svg";
import Mongo from "../../Assets/TechIcons/Mongo.svg";
import Postgresql from "../../Assets/TechIcons/Postgresql.svg";
import Tailwind from "../../Assets/TechIcons/Tailwind.svg";
import MUI from "../../Assets/TechIcons/MUI.svg";
import Csharp from "../../Assets/TechIcons/Csharp.svg";
import MySQL from "../../Assets/TechIcons/MySQL.svg";
import HTML from "../../Assets/TechIcons/HTML5.svg";
import Svelte from "../../Assets/TechIcons/Svelte.svg";
import Dart from "../../Assets/TechIcons/Dart.svg";
import Flutter from "../../Assets/TechIcons/Flutter.svg";
import Cypress from "../../Assets/TechIcons/Cypress.svg";
import Playwright from "../../Assets/TechIcons/Playwrite.svg";
import Selenium from "../../Assets/TechIcons/Selenium.svg";
import Pytest from "../../Assets/TechIcons/pytest.svg";
import Sqlite from "../../Assets/TechIcons/SQLite.svg";
import SQLServer from "../../Assets/TechIcons/SQLServer.svg";

function Techstack() {
  return (
    <Row style={{ justifyContent: "center", paddingBottom: "50px" }}>
      <Col xs={4} md={2} className="tech-icons">
        <img src={Angular} alt="go" width={25} height={25} />
        <div className="tech-icons-text">Angular</div>
      </Col>

      <Col xs={4} md={2} className="tech-icons">
        <img src={Csharp} alt="csharp" />
        <div className="tech-icons-text">C# </div>
      </Col>

      <Col xs={4} md={2} className="tech-icons">
        <img src={C} alt="C++" />
        <div className="tech-icons-text">C++</div>
      </Col>

      <Col xs={4} md={2} className="tech-icons">
        <img src={Cypress} alt="Cypress" height={30} width={30} />
        <div className="tech-icons-text">Cypress</div>
      </Col>

      <Col xs={4} md={2} className="tech-icons">
        <img src={Dart} alt="html" height={25} width={25} />
        <div className="tech-icons-text">Dart </div>
      </Col>

      <Col xs={4} md={2} className="tech-icons">
        <img src={Docker} alt="docker" />
        <div className="tech-icons-text">Docker</div>
      </Col>

      <Col xs={4} md={2} className="tech-icons">
        <img src={Flutter} alt="Flutter" height={25} width={25} />
        <div className="tech-icons-text">Flutter </div>
      </Col>

      <Col xs={4} md={2} className="tech-icons">
        <img src={Git} alt="git" />
        <div className="tech-icons-text">Git</div>
      </Col>

      <Col xs={4} md={2} className="tech-icons">
        <img src={HTML} alt="html5" height={25} width={25} />
        <div className="tech-icons-text">HTML5 </div>
      </Col>

      <Col xs={4} md={2} className="tech-icons">
        <img src={Java} alt="haskell" />
        <div className="tech-icons-text">Java</div>
      </Col>

      <Col xs={4} md={2} className="tech-icons">
        <img src={Javascript} alt="javascript" />
        <div className="tech-icons-text">Javascript</div>
      </Col>

      <Col xs={4} md={2} className="tech-icons">
        <img src={MUI} alt="mui" />
        <div className="tech-icons-text">Material UI</div>
      </Col>

      <Col xs={4} md={2} className="tech-icons">
        <img src={Mongo} alt="mongoDb" />
        <div className="tech-icons-text">Mongo DB</div>
      </Col>

      <Col xs={4} md={2} className="tech-icons">
        <img src={MySQL} alt="MySQL" height={25} width={25} />
        <div className="tech-icons-text">MySQL</div>
      </Col>

      <Col xs={4} md={2} className="tech-icons">
        <img src={Node} alt="node" />
        <div className="tech-icons-text">Node.Js</div>
      </Col>

      <Col xs={4} md={2} className="tech-icons">
        <img src={Playwright} alt="Playwright" height={25} width={25} />
        <div className="tech-icons-text">Playwright </div>
      </Col>

      <Col xs={4} md={2} className="tech-icons">
        <img src={Postgresql} alt="Postgresql" />
        <div className="tech-icons-text">Postgresql</div>
      </Col>

      <Col xs={4} md={2} className="tech-icons">
        <img src={Pytest} alt="pytest" width={25} height={25} />
        <div className="tech-icons-text">Pytest</div>
      </Col>

      <Col xs={4} md={2} className="tech-icons">
        <img src={Python} alt="Python" />
        <div className="tech-icons-text">Python</div>
      </Col>

      <Col xs={4} md={2} className="tech-icons">
        <img src={ReactIcon} alt="react" />
        <div className="tech-icons-text">React.Js</div>
      </Col>

      <Col xs={4} md={2} className="tech-icons">
        <img src={Svelte} alt="Svelte" height={25} width={25} />
        <div className="tech-icons-text">Svelte </div>
      </Col>

      <Col xs={4} md={2} className="tech-icons">
        <img src={Selenium} alt="Selenium" height={25} width={25} />
        <div className="tech-icons-text">Selenium </div>
      </Col>

      <Col xs={4} md={2} className="tech-icons">
        <img src={Sqlite} alt="Sqlite" height={25} width={25} />
        <div className="tech-icons-text">SQLite </div>
      </Col>

      <Col xs={4} md={2} className="tech-icons">
        <img src={SQLServer} alt="SQL Server" height={25} width={25} />
        <div className="tech-icons-text">SQL Server</div>
      </Col>

      <Col xs={4} md={2} className="tech-icons">
        <img src={Tailwind} alt="tailwind" />
        <div className="tech-icons-text">Tailwind CSS</div>
      </Col>

      <Col xs={4} md={2} className="tech-icons">
        <img src={Typescript} alt="typescript" />
        <div className="tech-icons-text">Typescript</div>
      </Col>
    </Row>
  );
}

export default Techstack;
